'use strict';
const angular = require('angular');

export class AttachmentListComponent {

  constructor(dialogs, $uibModal) {
    'ngInject';
    this.dialogs = dialogs;
    this.$uibModal = $uibModal;
  }

  isNonViewableMime(mime) {
    return !(this.isHtmlMime(mime) || this.isImageMime(mime) || this.isPdfMime(mime));
  }

  isImageMime(mime) {
    return mime.startsWith('image/');
  }

  isPdfMime(mime) {
    return mime === 'application/pdf';
  }

  isHtmlMime(mime) {
    return mime == 'text/html';
  }

  isWordMime(mime) {
    return mime == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
      mime == 'application/msword';
  }

  isPowerPointMime(mime) {
    return mime == 'application/vnd.openxmlformats-officedocument.presentationml.presentation' ||
      mime == 'application/vnd.ms-powerpoint';
  }

  isExcelMime(mime) {
    return mime == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
  }

  isOpenDocumentPresentation(mime) {
    return mime == 'application/vnd.oasis.opendocument.presentation';
  }

  isOpenDocumentText(mime) {
    return mime == 'application/vnd.oasis.opendocument.text';
  }

  isOpenDocumentSpreadsheet(mime) {
    return mime == 'application/vnd.oasis.opendocument.spreadsheet';
  }

  getIconByMime(mime) {
    if (this.isImageMime(mime))
      return "fa-file-image-o";
    else if (this.isPdfMime(mime))
      return "fa-file-pdf-o";
    else if (this.isHtmlMime(mime))
      return "fa-file-code-o";
    else if (this.isWordMime(mime))
      return "fa-file-word-o";
    else if (this.isOpenDocumentText(mime))
      return "fa-file-word-o";
    else if (this.isExcelMime(mime))
      return "fa-file-excel-o";
    else if (this.isOpenDocumentSpreadsheet(mime))
      return "fa-file-excel-o";
    else if (this.isPowerPointMime(mime))
      return "fa-file-powerpoint-o";
    else if (this.isOpenDocumentPresentation(mime))
      return "fa-file-powerpoint-o";
    else
      return "fa-file-o";
  }

  openSendAttachmentModal(attachment) {
    if (this.hook.openSendAttachmentModal) {
      this.hook.openSendAttachmentModal(attachment);
    }
  }
  
  removeAsset(idx) {
    var dlg = this.dialogs.confirm("Delete Attachment?", "<i class='fa fa-5x fa-fw text-danger fa-warning' style='float:right'></i>Do you really want to delete this attachment?<br/><br/>" + this.attachments[idx].filename);
    dlg.result.then(() => {
      this.service.patch({id: this.contextId}, [
        { "op": "remove", "path": "/attachments/"+idx },
      ], data => {
        this.attachments.splice(idx,1);
      });
    },err => {
      console.log("Could not remove attachment");
    });
  }
}

export default angular.module('conduu.attachmentList', [])
  .component('attachmentList', {
    template: require('./attachment-list.component.html'),
    bindings: {
      attachments: '<',
      contextId: '<',
      service: '<',
      hook: '<'
    },
    controller: AttachmentListComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/attachment-list/attachment-list.component.js